import { Routes } from '@angular/router';
import { CrudAthleteEnum } from '@libs/entity-lib';
import { AddressInfoComponent } from './address-info/address-info.component';
import { AthleteInfoComponent } from './athlete-info/athlete-info.component';
import { CredentialInfoComponent } from './credential-info/credential-info.component';
import { CrudDetailsInfoComponent } from './crud-details-info/crud-details-info.component';
import { QuickRegisterComponent } from './quick-register/quick-register.component';

export const crudProfileLibRoutes: Routes = [
  {
    path: CrudAthleteEnum.INFO,
    component: AthleteInfoComponent
  },
  {
    path: CrudAthleteEnum.ADDRESS_INFO,
    component: AddressInfoComponent
  },
  {
    path: CrudAthleteEnum.DETAILS,
    component: CrudDetailsInfoComponent
  },
  {
    path: CrudAthleteEnum.CREDENTIAL_INFO,
    component: CredentialInfoComponent
  },
  {
    path: CrudAthleteEnum.QUICK_REGISTER,
    component: QuickRegisterComponent
  }
];